import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultFixturePlayByPlayFlaggedEventsExportFieldNames } from "~pages/Reports/components/FixturePlayByPlayFlaggedEventDataTable/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportFixturePlayByPlayFlaggedEvents = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/fixture-play-by-play-flagged-events/export`, {
        method: "POST",
        body: {
          fieldNames: fieldNames || defaultFixturePlayByPlayFlaggedEventsExportFieldNames,
        },
      }),
  });
};
